'use client';

import { useEffect } from 'react';
import { unstable_isUnrecognizedActionError } from 'next/navigation';
import ApplicationFallback from '@framework/error-handling/ErrorBoundary/ApplicationFallback';
import Logger from '@framework/sentry/Logger';

import '@/dataroom/ui/styles/globalStyles.scss';

interface IGlobalErrorProps {
  error: Error & { digest?: string },
}

export default function GlobalError({ error }: IGlobalErrorProps): React.ReactNode {
  // A Server Action from another deployment: a reload loads the current one.
  const isUnrecognizedAction: boolean = unstable_isUnrecognizedActionError(error);

  useEffect(() => {
    if (isUnrecognizedAction) {
      window.location.reload();
      return;
    }

    Logger.error({
      message: 'Global error boundary',
      error,
      context: { digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="en" style={ { scrollBehavior: 'smooth' } }>
      <head>
        <link
          href="https://fonts.googleapis.com/css?family=Roboto:400,400i,500,500i,600,700,700i|Open+Sans:400,400i,500,500i,600,700,700i&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        { !isUnrecognizedAction && <ApplicationFallback /> }
      </body>
    </html>
  );
}
